/**
 * The signed-in shell (header search with Select/AutoComplete/Fuse, the PanelMenu sidebar) is its own chunk, so an
 * anonymous reader's entry no longer carries it (UX roadmap #20). App.vue renders it through lazyView; main.ts and
 * App.vue warm it whenever a member is, or is about to be, signed in, so members get no extra round trip.
 */
export function loadPrivateLayout() {
    return import( '@/layouts/Private.vue' );
}

/** Starts the download without rendering. A failure is left to App.vue's async component, which retries and reports it. */
export function warmPrivateLayout(): void {
    loadPrivateLayout().catch( () => {} );
}
